export default __webpack_public_path__ + "static/media/100_6218.cd739fe7.jpg";